import { render, staticRenderFns } from "./PasteImageModal.vue?vue&type=template&id=915a0c06&scoped=true&"
import script from "./PasteImageModal.vue?vue&type=script&lang=js&"
export * from "./PasteImageModal.vue?vue&type=script&lang=js&"
import style0 from "./PasteImageModal.vue?vue&type=style&index=0&id=915a0c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915a0c06",
  null
  
)

export default component.exports